import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container description__url"
}
const _hoisted_2 = ["href"]
const _hoisted_3 = { class: "container" }

import ListingPageDescription from './ListingPageDescription.vue'
import PodcastFollowButton from '@/app/components/listing/PodcastFollowButton.vue'

import { ListDescriptionViewPodcast } from '@/models/docs.list.podcasts.episodes'


export default /*@__PURE__*/_defineComponent({
  __name: 'ListingPageDescriptionPodcast',
  props: {
    view: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListingPageDescription, { view: __props.view }, {
    default: _withCtx(() => [
      (__props.view.originalUrl)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("a", {
              target: "_blank",
              href: __props.view.originalUrl,
              rel: "noreferrer noopener"
            }, " Listen to the original ", 8, _hoisted_2)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(PodcastFollowButton, {
          view: __props.view.followView
        }, null, 8, ["view"])
      ])
    ]),
    _: 1
  }, 8, ["view"]))
}
}

})